import { getters } from '/@/modules/core/app/helpers/store';
import { BaseTrackingService } from '/@/modules/core/app/services/abstracts/BaseTrackingService';
import { InboxRoute } from '/@/modules/inbox/routes/inbox.routes';
import { GuidanceStepRoute } from '/@/modules/guidancestep/routes/guidancestep.routes';
import { GuidanceStepNextStepsClickEventTracking } from '/@/modules/guidancestep/models/segmentevents/GuidanceStepNextStepsClickEventTracking';
import { InboxClickEventTracking } from '/@/modules/inbox/models/segmentevents/InboxClickEventTracking';

export class NavTrackingService extends BaseTrackingService {
  /**
   * @param navItem {NavItem}
   */
  track(navItem) {
    if (navItem.link === InboxRoute.DASHBOARD.path) {
      InboxClickEventTracking.dispatch(getters.auth.getUser());
    } else if (navItem.link === GuidanceStepRoute.NEXTSTEPS.path) {
      GuidanceStepNextStepsClickEventTracking.dispatch(getters.auth.getUser());
    }
  }
}

export default new NavTrackingService();
